import * as yup from 'yup'

const schema = yup.object().shape({
  observation: yup.string().required(),
})

export default schema
